import createModal from '../components/createModal';
import { $ } from '../util/DOM';

const initModals = () => {
  $('.modal-template').forEach((container) => {
    const keep = container.hasAttribute('keep');
    const modal = createModal(container.innerHTML, keep);

    if (container.hasAttribute('open')) {
      modal.open();
    }

    container.remove();
  });
};

export default initModals;
